import React from 'react';
import { Select, Form } from 'antd';
import transportFieldsConnect from '../../../common/hoc/transportFieldsConnect';
const Option = Select.Option;
const AdvertisingsTypes = ({ form, advertisingsTypes }) => {
  const { getFieldDecorator } = form;
  return (
    <Form.Item label="Наличие рекламы на ТС">
      {getFieldDecorator('advertising_key')(
        <Select
          style={{ width: '100%' }}
          allowClear={true}
          className="ui-select"
          mode="multiple"
          placeholder="Выберите опции"
          dropdownClassName="ui-select__dropdown-multiple"
          showArrow={true}
          maxTagCount={0}
          getPopupContainer={trigger => trigger.parentNode}
        >
          {advertisingsTypes &&
            advertisingsTypes.map(type => (
              <Option
                key={type.advertisingKey}
                value={type.advertisingKey}
                label={type.advertisingName}
              >
                {type.advertisingName}
              </Option>
            ))}
        </Select>
      )}
    </Form.Item>
  );
};

export default transportFieldsConnect(AdvertisingsTypes, ['advertisingsTypes']);
